import { Link, NavLink } from "react-router-dom";

export const Header = (props) => {
    return (
        <div className="header">
            <div className="header-wrapper">
                <div id="header" className="wrapper header-content">
                    <div className="title-block">
                        <Link className="header-top-ja" to='/'>
                            YUKI BAN
                        </Link>
                    </div>
                    <div className="menus">
                        <div className="menu-block">
                            <NavLink className={({ isActive }) => (isActive ? "menu selected-menu" : "menu")} to="/home">Home</NavLink>
                        </div>
                        <div className="menu-block">
                            <NavLink className={({ isActive }) => (isActive ? "menu selected-menu" : "menu")} to="/works">Works</NavLink>
                        </div>
                        <div className="menu-block">
                            <NavLink className={({ isActive }) => (isActive ? "menu selected-menu" : "menu")} to="/publication">Publication</NavLink>
                        </div>
                        <div className="menu-block">
                            <NavLink className={({ isActive }) => (isActive ? "menu selected-menu" : "menu")} to="/contact">Contact</NavLink>
                        </div>
                    </div>


                    <div className="option">
                        <ul className="dmenu">
                            <li className="dmenu__single">
                                <span className="init-bottom">Language</span>
                                <ul className="dmenu__second-level">
                                    <li className="dmenu-list" onClick={() => props.changeLang("jp")}><span>日本語</span></li>
                                    <li className="dmenu-list" onClick={() => props.changeLang("en")}><span>English</span></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};